import {
    NotificationResult,
    Notification,
    NotificationTypeValues
} from '../../graphql.generated';
import { enabledDynamicNotificationTypes } from '../config';

export function filterNotifications(
    notifications: Notification[],
    showMojoNotification?: boolean
): NotificationResult[] {
    return notifications.filter(
        (notification): notification is NotificationResult => {
            return (
                !('errorCode' in notification) &&
                enabledDynamicNotificationTypes(showMojoNotification).includes(
                    notification.type
                )
            );
        }
    );
}

export const orderNotifications = (
    notifications: NotificationResult[]
): NotificationResult[] => {
    return [...notifications].sort((notificationA, notificationB) => {
        if (notificationA.type === NotificationTypeValues.GetMortgage) {
            return -1;
        }

        return (
            new Date(notificationB.createdAt).getTime() -
            new Date(notificationA.createdAt).getTime()
        );
    });
};
